import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {providers} from '@core/providers';
import {throwIfAlreadyLoaded} from '@core/module-import-guard';
import { HttpClient } from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import Storage from '@core/utils/storage';
import {CoreStoreModule} from '@core/store';
import {HttpLoaderFactory} from '@app/share/translate';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";
import { LightgalleryModule } from 'lightgallery/angular';
import { MatDialog, MatDialogModule,MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharePopupComponent } from './components/share-popup/share-popup.component';
import { AlertDialogComponent } from "@core/components/alert-dialog/alert-dialog.component";

export function tokenGetter() {
  let coreState = Storage.get('core');
  return coreState?.login?.authorization?.token;
}

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    CoreStoreModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    [LightgalleryModule],
    MatDialogModule,
    AlertDialogComponent,
  ],
  providers: [
    providers,
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3000 } },
  ],
  declarations: [


    SharePopupComponent,

  ],
  exports: [

  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
